import { useNavigate } from "react-router-dom";

type KycBannerProps = {
  loading?: boolean;
  show?: boolean;
  className?: string;
  title?: string;
  description?: string;
  buttonText?: string;
};

const KycBanner = ({
  loading = false,
  show = true,
  className = "my-4",
  title = "Please complete your KYC.",
  description = "Complete your KYC Process to verify your identity",
  buttonText = "Add KYC",
}: KycBannerProps) => {
  const navigate = useNavigate();

  if (loading) {
    return <p>loading...</p>;
  }

  if (!show) {
    return null;
  }

  return (
    <div className={className}>
      <div
        className="p-3"
        style={{
          backgroundColor: "#FFDFDC",
          borderLeft: "4px solid #FF0000",
        }}
      >
        <div className="row align-items-center g-3">
          <div className="col-md">
            <div
              className="d-flex gap-3 align-items-center"
              style={{ color: "#FF0000" }}
            >
              <i className="fa-regular fa-user fa-2xl flex-shrink-0"></i>
              <div>
                <h6 className="m-0">{title}</h6>
                <p className="text-light-black mb-0">{description}</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-auto">
            <button
              className="bg-primary rounded-10 text-white fw-bold px-4 py-2 w-100 border-0"
              onClick={() => navigate("/settings?tab=kyc")}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycBanner;
